import { render, staticRenderFns } from "./app-man.vue?vue&type=template&id=788da709&scoped=true&"
import script from "./app-man.vue?vue&type=script&lang=js&"
export * from "./app-man.vue?vue&type=script&lang=js&"
import style0 from "./app-man.vue?vue&type=style&index=0&id=788da709&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788da709",
  null
  
)

export default component.exports